export const INITIALIZE = 'cv/device/INITIALIZE';
export const INITIALIZE_SUCCEEDED = 'cv/device/INITIALIZE_SUCCEEDED';
export const FETCH = 'cv/device/FETCH';
export const FETCH_FAILED = 'cv/device/FETCH_FAILED';
export const FETCH_SUCCEEDED = 'cv/device/FETCH_SUCCEEDED';
